const templateVariantSettings = {
  header: "COMPRESSED",
  homePage: "HomeTemplateV9",
  websiteName: "Greater Centennial FCU",
  speedBump: {
    borderWithRadious: true,
  },
  about: null,
  contact: null,
  footer: "SINGLE_PAGE",
};

module.exports = templateVariantSettings;
